// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","twoColumn":"Footer_twoColumn__V7WDb","rightColumn":"Footer_rightColumn__uFGc1"};